import {ReactNode} from 'react';

import {OrderStatus} from 'core/dictionaries';

import {PackageTypes} from './gtins';

export enum OrdersAccessors {
    participant = 'participant',
    id = 'orderId',
    createdDate = 'createdAt',
    closedDate = 'closedAt',
    quantity = 'totalMarkingCodes',
    status = 'status',
}

export interface OrdersGridRawRow {
    participant?: string;
    orderId: string;
    createdAt: string;
    closedAt: string;
    totalMarkingCodes: number;
    status: OrderStatus;
}

export interface OrdersGridFormattedRow {
    [OrdersAccessors.participant]?: string;
    [OrdersAccessors.id]: ReactNode;
    [OrdersAccessors.createdDate]: string;
    [OrdersAccessors.closedDate]: string;
    [OrdersAccessors.quantity]: number;
    [OrdersAccessors.status]: ReactNode;
}

export interface OrderFormData {
    country?: string;
    factoryId?: string;
    factoryName?: string;
    productionLineId?: string;
    productionLineName?: string;
    productGroupCode?: string;
    type?: keyof typeof PackageTypes;
}

export interface OrderProductsData {
    type?: keyof typeof PackageTypes;
    gtin?: string;
    quantity?: string;
    templateId?: string;
    productName?: string;
    productGroupCode?: string;
}

export interface OrderCreateData extends OrderFormData {
    products: Array<OrderProductsData>;
}

export enum OrdersDetailProductsAssessors {
    templateId = 'templateId',
    gtin = 'gtin',
    productId = 'productId',
    productName = 'productName',
    productVendorCode = 'productVendorCode',
    productGroupCode = 'productGroupCode',
    quantity = 'quantity',
    availableQuantity = 'availableQuantity',
    type = 'type',
}

export interface OrderDetailProductsRaw {
    templateId: string;
    gtin: string;
    productId: string;
    productName: string;
    productVendorCode: string;
    productGroupCode: string;
    quantity: number;
    availableQuantity: number;
    packageType: PackageTypes;
}
export interface OrderDetailProductsFormattedRow {
    productId: string;
    productName: string;
    quantity: number;
    availableQuantity: string;
    gtin: string;
}
export interface OrderDetailRaw {
    orderId: string;
    createdAt: string;
    status: OrderStatus;
    totalMarkingCodes: number;
    factoryId: string;
    country: string;
    productionLineId: string;
    productGroupCode: string;
    products: Array<OrderDetailProductsRaw>;
    errors?: OrderDetailError[];
    availableCodes: number;
}

export interface OrderDetailError {
    code: string;
    message: string;
}

export interface OrderDetailFormatted {
    orderId: string;
    createdAt: string;
    status: string;
    totalMarkingCodes: string;
    factoryId: string;
    country: string;
    productionLineId: string;
    availableCodes: string;
    errors?: string[];
}

export interface LabelsForm {
    format: String;
    quantity: Number;
    orderId: String;
    gtin: String;
    template: String;
}
